import { defineAction } from '~/prix'
import { z } from 'zod'
import creditEconomicMovementUpdateAction from './creditEconomicMovementUpdate.action.json' with { type: 'json' }
import { creditEconomicMovementUpdateInputObject } from '../creditEconomicMovementObject'

const creditEconomicMovementUpdateDefinition = defineAction({
  ...creditEconomicMovementUpdateAction,

  input: creditEconomicMovementUpdateInputObject,
  output: z.object({}),
})

export default creditEconomicMovementUpdateDefinition

